import script from "./detailSection.vue?vue&type=script&setup=true&lang=js"
export * from "./detailSection.vue?vue&type=script&setup=true&lang=js"

import "./detailSection.vue?vue&type=style&index=0&id=79cd1d97&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79cd1d97"]])

export default __exports__